  (function() {
    window.CartPage = window.CartPage || new function() {
    //runs once per page load
    var self = this;
    self.updateCart = function() {
      $s.showLoadingOverlay();
      $s.getJson({url: '/?sections=cart_content', success: function(data){
        var section = document.querySelector('.cart-content');
        $s.updateDynamicContent(section, data['cart_content']);

        var summaryWrapper = document.querySelector('#cart .summary-column');
        if (section.querySelector('.cart-items')) {
          summaryWrapper.style.display = '';
          const cartItems = document.querySelectorAll('.cart-items .item').length;
          let cartTotal = 0;
          document.querySelectorAll('.cart-items .item').forEach(function(item){
            const value = item.dataset.price ? Number(item.dataset.price.replace(',', '')) : 0;
            cartTotal += value;            
          });
          if (cartItems > 0) {
            document.querySelector('.order-summary .cart-items-size').textContent = `(${cartItems})`;
            document.querySelector('.order-summary .subtotal').textContent = `$${cartTotal}`;
            document.querySelector('.order-summary .estimated').textContent = `$${cartTotal}`;
          } else {
            summaryWrapper.style.display = 'none';
            const titleRow = document.querySelector('#cart .cart-title-row');
            titleRow.classList.remove('flex');
            titleRow.classList.add('hide');
            document.querySelector('#cart .cart-recommended').style.display = 'none';
          }
        } else {
          summaryWrapper.style.display = 'none';
          const titleRow = document.querySelector('#cart .cart-title-row');
          titleRow.classList.remove('flex');
          titleRow.classList.add('hide');
          document.querySelector('#cart .cart-recommended').style.display = 'none';
        }
        $s.globalEval(data['cart_content']);
        $s.hideLoadingOverlay();

        //document.dispatchEvent(new Event('swatCartUpdated'))
        
      }});
    }

    self.updateItemsQuantity = function(items, quantity){
      var data = {updates: {}}
      items.forEach(function(item) {
        console.log(item);
        data.updates[item.dataset.key] = quantity;
      });
      console.log(data);
      // return false;
      postUpdate(data);
    }

    function postUpdate(data) {
      //$s.showLoadingOverlay();
      $s.post({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        //success: $s.addToCartSuccess,
        success: function() {
          //overlay reopened by updateCart()
          // $s.hideLoadingOverlay();          
          self.updateCart();
        },
        error: $s.addToCartFail
      });
    }

    // create a custom event
    var swymEvent = new Event("swymFinallyLoad");

    // create a delayed object
    var myDelayedObject = {
      delay: function() {
        var self = this;
          //Executed after SWYM has loaded all necessary resources.
          function onSwymLoadCallback(swat) {
            // Please make all SWYM-related API calls inside this function.
            // You can use the swat argument within this scope.
            if (window._swat) {
              setTimeout(function(){
                self.complete();
              }, 3000)              
            }        
          }
          if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
          }
          window.SwymCallbacks.push(onSwymLoadCallback);
      },
      complete: function() {
        // dispatch the custom event when the object is completed
        document.dispatchEvent(swymEvent);
      }
    };
    // call the delay method on the delayed object
    myDelayedObject.delay();

    // listen for the custom event
    document.addEventListener("swymFinallyLoad", function() {
      console.log("Swym Scripts Loaded.");
    });
  
  };
  $s.checkBundle();

  //runs every time #cart div is replaced
  var cart = document.getElementById('cart');
  var itemsCount = 0;
  
  cart.querySelectorAll('[data-key]').forEach(function(item){
    if (item.querySelector('.quantity-box input[type=number]')) {
      itemsCount += item.querySelector('.quantity-box input[type=number]').value/1;
    } else {
      itemsCount += 1;
    }
  });var cartCountElement = document.querySelectorAll('.cart-count');

  if(cartCountElement.length) {
    cartCountElement.forEach((element) => {
      setTimeout(() => {
        element.innerHTML = itemsCount>0?itemsCount:'';        
      }, 10);
    })
  }
  

  cart.querySelectorAll('.remove').forEach(function(item) {
    item.addEventListener('click', function(e){
      e.preventDefault();
      var items = $s.getItemsToUpdate(this.closest('.item'), 0);
      CartPage.updateItemsQuantity(items, 0);
    });
  });
  

  cart.querySelectorAll('input[type=number]').forEach(function(item) {
    item.addEventListener('change', function(e){
      var items = $s.getItemsToUpdate(this.closest('.item'), this.value);
      CartPage.updateItemsQuantity(items, this.value);
    });
  });console.log('checking instructions');
  var checkInstructions = document.getElementById('chk-instructions');
  var addNote = document.querySelector(".allow-gift");
  var plusIcon = document.querySelector(".allow-gift .plus");
  var minusIcon = document.querySelector(".allow-gift .minus");
  var allowBlankCard = document.getElementById("allow-blank-card");

  if (checkInstructions) {
    var checkInstructionsChange = function() {
      console.log('here3');
      var note = document.getElementById('instructions-note');
      if (checkInstructions.checked) {
        console.log('aaa');
        note.classList.remove("hide");
        checkInstructions.checked = false;
        minusIcon.classList.remove("hide");
        plusIcon.classList.add("hide");
      } else {
        console.log('bbb');
        note.classList.add("hide");
        checkInstructions.checked = true;
        minusIcon.classList.add("hide");
        plusIcon.classList.remove("hide");
        var textarea = note.querySelector('textarea');
        if (textarea.value != '') {
          textarea.value = '';
          $s.dispatchEvent(textarea, 'change');
        }
      }
    }

    var enableBlankCard = function() {
      var note = document.getElementById('instructions-note');
      if (allowBlankCard.checked) {
        note.classList.add("blank-card");
        var textarea = note.querySelector('textarea');
        textarea.disabled = true;
        textarea.value = 'Send me a blank card';
        $s.dispatchEvent(textarea, 'change');
        //allowBlankCard.checked = true;
      } else {
        var textarea = note.querySelector('textarea');
        note.classList.remove("blank-card");
        textarea.disabled = false;
        textarea.value = '';
        $s.dispatchEvent(textarea, 'change');
        //allowBlankCard.checked = false;
      }
    }

    checkInstructions.labels[0].addEventListener('keypress', function(event) {
      if (event.keyCode==13) {
        addNote.click();
      }
    });

    addNote.addEventListener('click', checkInstructionsChange);
    allowBlankCard.addEventListener('click', enableBlankCard);
    checkInstructionsChange();
    //enableBlankCard();
  }$s.validateBundlesInHTML(document.querySelectorAll('#cart .item'));


})();

// var protection_buttons = document.querySelectorAll('.item-protection-button');
// var protectionPopup = document.querySelector('.warranty-popup-wrapper');
// var protectionPopupClose = document.querySelector('.warranty-popup-wrapper .close-popup');
// protection_buttons.forEach(function(protection_button){
//   protection_button.addEventListener('click', function(){
//     protectionPopup.classList.add('show');
//   });
// });
// protectionPopupClose.addEventListener('click', function(){
//   protectionPopup.classList.remove('show');
// });

function addProtectionToCart(){
  var isInputChecked = document.querySelector('.protection-plan-options input:checked');
    var closetParent = event.target.closest('.protection-plan-options-wrapper');
    console.log(closetParent);
    var id = isInputChecked && isInputChecked.closest('.protection-plan').dataset.protectionId;
    var product = { id: "", quantity: "", properties: {} }, formData = { items: []};
    product.properties["_timestamp"] = closetParent.dataset.timestamp
    product.properties["_product name"] = closetParent.dataset.productName;
    product.properties["_product price"] = closetParent.dataset.productPrice;
    product.properties["_product sku"] = closetParent.dataset.productSku;
    product.quantity = 1;
    product.id = id;
    formData.items.push(product);
    console.log(formData);
    // return formData;
    $s.showLoadingOverlay();
    $s.post({
      url: '/cart/add.js',
      data: formData,
      success: function(){
        $s.addToCartSuccess();
      },
      error: function(response){
        $s.addToCartFail(response.description);
      }
    })
}

var popupAddToCartButton = document.querySelector('.warranty-popup .add-plan');
popupAddToCartButton.addEventListener('click', addProtectionToCart);

class ProtectionPlanButton extends HTMLElement{
  constructor() {
    super();
    this.protectionButton = this.querySelector('.item-protection-button');
    this.popupContainer = document.querySelector('.warranty-popup-wrapper');
    this.popupContainerClose = document.querySelector('.warranty-popup-wrapper .close-popup');
    this.protectionButton.addEventListener('click', this.updatePopupProtectionPrice.bind(this));
    this.popupContainerClose.addEventListener('click', this.hidePopup.bind(this));
    this.loadProtectionButtonPrice(this.protectionButton);
  }
  updateProductType(product_type){
    if (
        product_type== "bands" ||
        product_type.indexOf("engagement-ring") > -1 ||
        product_type.indexOf("enhancers") > -1 ||
        product_type.indexOf("high-jewelry-ring") > -1 ||
        product_type=="ring" ||
        product_type=="rings"
      ) {
        return true;
      }
      return false;
  }
  updatePriceRange(protection_variant_list,variant_price){
    var range = ''
    for (var obj in protection_variant_list) {
      var lower_price_range = obj.split(" / ")[1].split("-")[0] * 100;
      var higher_price_range = obj.split(" / ")[1].split("-")[1] * 100;
      if (variant_price >= lower_price_range && variant_price <= higher_price_range) {
        range = obj.split(" / ")[1];
        break;
      }
    }
    return range;
  }
  updateProtectionButtonPrice(item){
    var itemPrice = item.dataset.itemPrice;
    var product_type = item.dataset.itemType;
    var is_bridal_product = false,protection_variant_list,price_range = "";
    is_bridal_product = this.updateProductType(product_type);
    if(is_bridal_product){
      protection_variant_list = window.protection.protection_product_lifetime;
      price_range = this.updatePriceRange(protection_variant_list,itemPrice);
      return protection_variant_list[`3 / ${price_range}`][0];
    }else{
      protection_variant_list = window.protection.protection_product_3y;
      price_range = this.updatePriceRange(protection_variant_list,itemPrice);
      return protection_variant_list[`1 / ${price_range}`][0];
    }
  }
  updateProtectionPriceInPopup(item){
    var itemPrice = item.dataset.itemPrice;
    var product_type = item.dataset.itemType;
    var is_bridal_product = false,protection_variant_list,price_range = "";
    is_bridal_product = this.updateProductType(product_type);
    console.log(is_bridal_product);
    if(is_bridal_product){
      protection_variant_list = window.protection.protection_product_lifetime;
      price_range = this.updatePriceRange(protection_variant_list,itemPrice);
      document.getElementById('popup-protection-option-1').value = "3 Year";
      document.getElementById('popup-protection-option-2').value = "5 Year";
      document.getElementById('popup-protection-option-3').value = "10 Years";
      document.querySelector('.protection-plan-option-1 .update-year').innerText = "3 Year";
      document.querySelector('.protection-plan-option-2 .update-year').innerText = "5 Year";
      document.querySelector('.protection-plan-option-3 .update-year').innerText = "10 Years";
      // document.querySelector('.protection-plan-option-3 sup').style.display = "inline";
      return [
              ...protection_variant_list[`3 / ${price_range}`],
              ...protection_variant_list[`5 / ${price_range}`],
              ...protection_variant_list[`10 / ${price_range}`],
            ];
    } else {
      protection_variant_list = window.protection.protection_product_3y;
      price_range = this.updatePriceRange(protection_variant_list,itemPrice);
      document.getElementById('popup-protection-option-1').value = "1 Year";
      document.getElementById('popup-protection-option-2').value = "2 Year";
      document.getElementById('popup-protection-option-3').value = "3 Year";
      document.querySelector('.protection-plan-option-1 .update-year').innerText = "1 Year";
      document.querySelector('.protection-plan-option-2 .update-year').innerText = "2 Year";
      document.querySelector('.protection-plan-option-3 .update-year').innerText = "3 Year";
      return [
        ...protection_variant_list[`1 / ${price_range}`],
        ...protection_variant_list[`2 / ${price_range}`],
        ...protection_variant_list[`3 / ${price_range}`],
      ];
    }
  }
  loadProtectionButtonPrice(event){
    var productPrice = event.dataset.itemPrice;
    var buttonPrice = this.updateProtectionButtonPrice(event);
    console.log(buttonPrice);
    this.protectionButton.querySelector("span").innerText = $s.formatMoney(buttonPrice).replace('.00', '');
  }
  updatePopupProtectionPrice(event){
    console.log(event.target);
    var [price_option1,variant_option1,price_option2,variant_option2,price_option3,variant_option3] = this.updateProtectionPriceInPopup(event.target);
    document.querySelector('.protection-plan-option-1').dataset.protectionId = variant_option1;
    document.querySelector('.protection-plan-option-1 .update-price').innerText = $s.formatMoney(price_option1).replace('.00', '');
    document.querySelector('.protection-plan-option-2').dataset.protectionId = variant_option2;
    document.querySelector('.protection-plan-option-2 .update-price').innerText = $s.formatMoney(price_option2).replace('.00', '');
    document.querySelector('.protection-plan-option-3').dataset.protectionId = variant_option3;
    document.querySelector('.protection-plan-option-3 .update-price').innerText = $s.formatMoney(price_option3).replace('.00', '');
    document.querySelector('.protection-plan-options-wrapper').dataset.timestamp = event.target.dataset.timestamp;
    document.querySelector('.protection-plan-options-wrapper').dataset.productName = event.target.dataset.itemTitle;
    document.querySelector('.protection-plan-options-wrapper').dataset.productPrice = event.target.dataset.itemPrice;
    document.querySelector('.protection-plan-options-wrapper').dataset.productSku = event.target.dataset.variantSku;
    this.popupContainer.classList.add('show');
  };
  hidePopup(){
    this.popupContainer.classList.remove('show');
  };
}

customElements.define('protection-plan-button', ProtectionPlanButton);